import { useEffect } from 'react';

/**
 * Sets the document title + a `<meta name="robots">` directive on mount.
 * Restores previous values on unmount so it doesn't leak between routes.
 */
export function usePageMeta({ title, robots = 'index, follow' } = {}) {
  useEffect(() => {
    const previousTitle = document.title;
    if (title) document.title = title;

    let created = false;
    let meta = document.querySelector('meta[name="robots"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      document.head.appendChild(meta);
      created = true;
    }
    const previousRobots = meta.getAttribute('content');
    meta.setAttribute('content', robots);

    return () => {
      if (title) document.title = previousTitle;
      if (created) {
        meta.remove();
      } else if (previousRobots !== null) {
        meta.setAttribute('content', previousRobots);
      }
    };
  }, [title, robots]);
}
